import versions from './data/topic-catalog-versions.json' with { type: 'json' };
import type { TopicCollection, TopicSelector } from './topicClient';
export const CURRENT_TOPIC_CATALOG_HASH = versions.current.catalogContentSha256;
export type SourcePassage = { id: number; text: string; major: number; minor: number };
const CORPUS_SHA256 = '5c23bc35f15c91c87fbdbf4b5866b4bbfe16b1c3bab6d9bb9d70312933e1ccf1';
export function topicCollectionVersion(collection: TopicCollection): 'current' | 'historical' | null {
  const p = collection?.provenance;
  if (!p || p.corpusSha256 !== CORPUS_SHA256 || p.completeThematicRoute !== false || !/^[a-f0-9]{40}$/.test(p.catalogCommit)) return null;
  if (p.reviewVersion === versions.current.reviewVersion && p.catalogContentSha256 === CURRENT_TOPIC_CATALOG_HASH) return 'current';
  if (p.reviewVersion === versions.historical.reviewSource.version && p.catalogCommit === versions.historical.sourceCommit && p.catalogContentSha256 === undefined) return 'historical';
  return null;
}
/** Reconstruct only the accepted historical selector, never trust a saved chapter list. */
export function historicalTopicPassages(selector: TopicSelector, corpus: SourcePassage[]): SourcePassage[] {
  if (corpus.length !== 512 || new Set(corpus.map(p => p.id)).size !== 512) return [];
  const old = versions.historical;
  const glyphs = new Map<string, string>();
  for (let i = 0; i < old.glyphPairs.length; i += 2) glyphs.set(old.glyphPairs[i], old.glyphPairs[i + 1]);
  const normalize = (text: string) => [...text].map(c => glyphs.get(c) ?? c).join('');
  const plain = (text: string) => normalize(text.replace(/[⑴-⒇\s]/gu, ''));
  const concept = old.concepts.find(c => normalize(c.label) === normalize(selector.query));
  if (selector.kind === 'chapter') return corpus.filter(p => String(p.id) === selector.query);
  if (selector.kind === 'reviewed') {
    if (!concept) return [];
    const refs = new Set(old.relations.filter(r => r.concepts.includes(concept.id)).map(r => r.coordinate));
    return corpus.filter(p => refs.has(p.major + '.' + p.minor));
  }
  const terms = (concept?.terms ?? [selector.query]).map(plain).filter(Boolean);
  return corpus.filter(p => terms.some(term => plain(p.text).includes(term)));
}
